import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private activeLanguage$: BehaviorSubject<string>;
  private availableLanguages = environment.languages;

  constructor(private translate: TranslateService) {
    const activeLanguage: string =
      sessionStorage.getItem('activeLanguage') ||
      this.translate.getDefaultLang();
    this.activeLanguage$ = new BehaviorSubject(activeLanguage);
  }

  public getActiveLanguage(): BehaviorSubject<string> {
    return this.activeLanguage$;
  }

  public setActiveLanguage(language: string): void {
    this.translate.use(language);
    sessionStorage.setItem('activeLanguage', language);
    this.activeLanguage$.next(language);
  }

  public getAvailableLanguages(): string[] {
    return this.availableLanguages;
  }
}
